export default function guest({ store, next }) {
    if(store.getters['Profile/authenticated'] || localStorage.getItem('token')){
        return next({
            name: 'chat'
        })
    }

    return next()
}